import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Row, Col } from "antd";
import "swiper/css/navigation";
import imgIcon from "../images/goole-icon.png"
import img1 from "../images/logo-1.png"
import { CiCircleChevUp } from "react-icons/ci";
import { CiCircleChevDown } from "react-icons/ci";
import ProductSlider from '../components/Productslider';
import axios from 'axios';
import { addToCart, productInCart } from '../helper/cart';
import { useNavigate } from 'react-router-dom';
// import img12 from '../images/silder1/12.png'

// import 'swiper/css'; 
// import 'swiper/css/pagination';
function Productdescription({ initialCount = 1, min = 1, max = 10, onChange }) {
  const navigate = useNavigate()
  let { sku } = useParams()
  const [productData, setProductData] = useState(null)
  const [count, setCount] = useState(initialCount);
  const [formData, setFormData] = useState({
    sku,
    quantity: count,
    ringSize: ''
  })

  useEffect(() => {
    setFormData({ ...formData, quantity: count })
  }, [count])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const fetchProductBySku = async () => {
    axios.post('/api/products', {

      SKU: [sku],
      Include: ["webCategories", "Media"],
      Filter: ["Orderable", "OnPriceList", "InStock"]
    }, {
      headers: {
        'Content-Type': 'application/json',
        // 'Accept': 'application/json',
      }
    }).then(response => {
      const productData = response.data.data.Products;
      console.log('productData', productData[0])
      setProductData(productData[0])
      const itemInCart = productInCart(productData[0].SKU)
      if (itemInCart) {
        setCount(itemInCart.quantity)
      }
    })
      .catch(error => {
        console.log('error', error)
      });
  }

  useEffect(() => {
    fetchProductBySku()
  }, [sku])

  console.log('sku', sku)

  const handleIncrement = () => {
    if (count < max) {
      const newCount = count + 1;
      setCount(newCount);
      if (onChange) {
        onChange(newCount);
      }
    }
  };

  const handleDecrement = () => {
    if (count > min) {
      const newCount = count - 1;
      setCount(newCount);
      if (onChange) {
        onChange(newCount);
      }
    }
  };


  const handleCart = (e) => {
    e.preventDefault()
    addToCart(formData)
    navigate('/cart')
  }

  return (

    <>
      <section className="product-card">
        <div className="container">
          <Row justify={'center'} gutter={25}>
            <Col  xs={24} md={12} sm={24}>
              <ProductSlider images={productData?.Images} />
            </Col>
            <Col xs={24} md={12} sm={24}>
              <form onSubmit={handleCart}>
                <div className="product-txt">
                  <img src={img1} alt="img" />
                  <h2>{productData?.Description}</h2>
                  <div className="start-mention">
                    {/* <ul style={{ listStyle: "none", display: "flex", padding: 0 }}>
                    {[1, 2, 3, 4, 5].map((index) => (
                      <li
                        key={index}
                        onClick={() => handleClick(index)}
                        onMouseEnter={() => handleHover(index)}
                        onMouseLeave={handleMouseOut}
                        style={{ cursor: "pointer", fontSize: "24px", fontWeight: "500" }}
                      >
                        {index <= (hover || rating) ? <FaStar color={'gold'} /> : <CiStar color={"gray"} />}
                      </li>
                    ))}
                  </ul> */}
                    {/* <div className="etron">
                    <p>(No reviews) </p>
                    <a href="/">
                      <span>Write a Review</span>
                    </a>
                  </div> */}
                  </div>
                  {/* <p className='product-dis-p'>With AR controls and ergonomics, this Hand Gun Caliber Carbine uses standard Glock® magazines. Lightweight, controllable, the AFMG-9 16" makes for an excellent home or personal defense weapon and allows the shooter to share magazines with the sidearm of choice.</p> */}
                  <p className='product-dis-p'>{productData?.ShortDescription}</p>

                  <div className="product-price">
                    <h3>${productData?.ShowcasePrice?.Value.toFixed(2)}</h3>
                    {productData?.ConfigurationModel?.RingSizeOptions?.length && <label className='ring-size' htmlFor="">
                      <span>Ring Size:</span>
                      <select name='ringSize' onChange={handleChange} value={formData.ringSize} required>
                        {productData?.ConfigurationModel?.RingSizeOptions.map((item, ind) => <option key={ind} value={item.Size}>{item.Size}</option>)}
                      </select>
                    </label>}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <button
                      type='button'
                        onClick={handleDecrement}
                        style={{
                          padding: "10px",
                          fontSize: "16px",
                          cursor: count > min ? "pointer" : "not-allowed",
                          backgroundColor: count > min ? "#ccc" : "#f5f5f5",
                          border: "1px solid #ddd",
                        }}
                        disabled={count <= min}
                      >
                        <CiCircleChevDown />
                      </button>
                      <span style={{ fontSize: "18px", fontWeight: "bold" }}>{count}</span>
                      <button
                      type='button'
                        onClick={handleIncrement}
                        style={{
                          padding: "10px",
                          fontSize: "16px",
                          cursor: count < max ? "pointer" : "not-allowed",
                          backgroundColor: count < max ? "#ccc" : "#f5f5f5",
                          border: "1px solid #ddd",
                        }}
                        disabled={count >= max}
                      >
                        <CiCircleChevUp />
                      </button>
                    </div>

                  </div>
                </div>
                <div className="main-button-price">
                  <ul>
                    <li className='product-btn-1'>
                      <button type='submit'>Add to Cart</button>
                    </li>
                    <li className='product-btn-2'>
                      <button type='button'>Add To Wishlist</button>
                    </li>

                  </ul>

                </div>
                {/* <div className="main-button-looper">
                  <button><img src={imgIcon} alt="img" />G Pay</button>
                </div> */}
              </form>




            </Col>
          </Row>
          {productData?.Videos && <div className="product-video" style={{ marginTop: `40px` }}>
            {productData?.Videos[0] && <video className='product-video' muted loop autoPlay>
              <source src={productData?.Videos[0].DownloadUrl} />
            </video>}
          </div>}
        </div>
      </section>
    </>
  )
}

export default Productdescription
